import { defineComponent as p, openBlock as t, createElementBlock as o, mergeProps as u, unref as e, renderSlot as h, createElementVNode as n, createCommentVNode as H } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, m = { key: 1 }, f = { key: 2 }, w = { key: 3 }, k = { key: 4 }, M = { key: 5 }, Z = {
  name: "ScalarIconArrowUDownRight"
}, V = /* @__PURE__ */ p({
  ...Z,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = g(s);
    return (i, l) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      h(i.$slots, "default"),
      e(a) === "bold" ? (t(), o("g", A, l[0] || (l[0] = [
        n("path", { d: "M232.49,176.49l-48,48a12,12,0,0,1-17-17L195,180H88A68,68,0,0,1,88,44h88a12,12,0,0,1,0,24H88a44,44,0,0,0,0,88H195l-27.52-27.51a12,12,0,1,1,17-17l48,48A12,12,0,0,1,232.49,176.49Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (t(), o("g", m, l[1] || (l[1] = [
        n("path", {
          d: "M224,168l-48,48V120Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M229.66,162.34l-48-48A8,8,0,0,0,168,120v40H88a48,48,0,0,1,0-96h88a8,8,0,0,0,0-16H88a64,64,0,0,0,0,128h80v40a8,8,0,0,0,13.66,5.66l48-48A8,8,0,0,0,229.66,162.34ZM184,196.69V139.31L212.69,168Z" }, null, -1)
      ]))) : e(a) === "fill" ? (t(), o("g", f, l[2] || (l[2] = [
        n("path", { d: "M229.66,173.66l-48,48A8,8,0,0,1,168,216V176H88A64,64,0,0,1,88,48h88a8,8,0,0,1,0,16H88a48,48,0,0,0,0,96h80V120a8,8,0,0,1,13.66-5.66l48,48A8,8,0,0,1,229.66,173.66Z" }, null, -1)
      ]))) : e(a) === "light" ? (t(), o("g", w, l[3] || (l[3] = [
        n("path", { d: "M228.24,172.24l-48,48a6,6,0,0,1-8.48-8.48L209.51,174H88A62,62,0,0,1,88,50h88a6,6,0,0,1,0,12H88a50,50,0,0,0,0,100H209.51l-37.75-37.76a6,6,0,0,1,8.48-8.48l48,48A6,6,0,0,1,228.24,172.24Z" }, null, -1)
      ]))) : e(a) === "regular" ? (t(), o("g", k, l[4] || (l[4] = [
        n("path", { d: "M229.66,173.66l-48,48a8,8,0,0,1-11.32-11.32L204.69,176H88A64,64,0,0,1,88,48h88a8,8,0,0,1,0,16H88a48,48,0,0,0,0,96H204.69l-34.35-34.34a8,8,0,0,1,11.32-11.32l48,48A8,8,0,0,1,229.66,173.66Z" }, null, -1)
      ]))) : e(a) === "thin" ? (t(), o("g", M, l[5] || (l[5] = [
        n("path", { d: "M226.83,170.83l-48,48a4,4,0,0,1-5.66-5.66L214.34,172H88A60,60,0,0,1,88,52h88a4,4,0,0,1,0,8H88a52,52,0,0,0,0,104H214.34l-41.17-41.17a4,4,0,0,1,5.66-5.66l48,48A4,4,0,0,1,226.83,170.83Z" }, null, -1)
      ]))) : H("", !0)
    ], 16));
  }
});
export {
  V as default
};
